import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  data: [],
  yourAssessmentLoading: false,
  yourAssessmentScorecards: [],
};

export const popperScorecardsSlice = createSlice({
  name: "popperScorecards",
  initialState,
  reducers: {
    popperScorecardsStart: (state) => ({
      ...state,
      loading: true,
      error: false
    }),
    popperScorecardsSuccess: (state, action) => ({
      ...state,
      loading: false,
      data: action.payload
    }),
    popperScorecardsFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    updateYourAssessmentLoading: (state, action) => ({
      ...state,
      yourAssessmentLoading: action.payload
    }),
    updateYourAssessmentScorecards: (state, action) => ({
      ...state,
      yourAssessmentScorecards: action.payload
    })
  },
});

const { actions, reducer } = popperScorecardsSlice;

export const { 
  popperScorecardsStart,
  popperScorecardsSuccess,
  popperScorecardsFailure,
  updateYourAssessmentLoading,
  updateYourAssessmentScorecards,
} = actions;

const updateYourAssessentInfo = (dispatch, updatedScorecards = []) => {
  dispatch(updateYourAssessmentLoading(false))
  dispatch(updateYourAssessmentScorecards(updatedScorecards))
}

export const getPopperScorecards = (useCaseId, yourAssessment = false) => (dispatch) => {
  if (yourAssessment) dispatch(updateYourAssessmentLoading(true))
  dispatch(popperScorecardsStart());
  apiService.get(`${Constants.API.USE_CASE_DETAIL}/${useCaseId}${Constants.API.SCORE_CARD_TERM}`).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(popperScorecardsSuccess(data?.data));
      if (yourAssessment) {
        updateYourAssessentInfo(dispatch, data?.data?.filter(scorecardInfo => scorecardInfo?.addedToScoreCard));
      }
    } else {
      dispatch(popperScorecardsFailure());
      if (yourAssessment) updateYourAssessentInfo(dispatch);
    }
  }).catch(() => {
    dispatch(popperScorecardsFailure());
    if (yourAssessment) updateYourAssessentInfo(dispatch);
  })
}

export default reducer;
